import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import IdeaIndexPage from '@buyside/components/presentation/IdeaIndexPage/ideaIndexPage';

import { publicIdeasUrl } from '@buyside/util/urlHelper';

const PublicIdeaIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="idea index">
      <Router basename={publicIdeasUrl()}>
        <IdeaIndexPage isPublic />
      </Router>
    </ErrorBoundary>
  );
};

export default PublicIdeaIndexPageRoot;
